import { IDataGridColumnConfiguration } from '@trackman/baseball-shared-components';
import { DataKey } from 'enums/DataKey';
import { IObservableArray, makeAutoObservable } from 'mobx';
import uuid from 'uuid';
import { AllColumns } from '../pages/Verify/Components/EditPlaysGrid/EditPlaysColumnConfigurations';

const columnKey = 'columns';
const columnsVersionKey = 'columns-version';

export class ColumnsStore {
  constructor() {
    this.initializeColumnsFromLocalStorage();
    makeAutoObservable(this);
  }

  isStrikeZoneFeatureEnabled = false;

  isConfiguratorVisible = false;

  columns: IDataGridColumnConfiguration[] = AllColumns;

  shouldUpdate = '';

  columnsVersion = '1.0';

  initializeColumnsFromLocalStorage = (): void => {
    const clientVersion = localStorage.getItem(columnsVersionKey);
    if (clientVersion !== this.columnsVersion) {
      localStorage.setItem(columnKey, JSON.stringify(AllColumns));
      this.columns = AllColumns;
      this.setColumnsVersion();
      return;
    }

    const storedColumns = localStorage.getItem(columnKey);
    if (storedColumns) {
      const parsedColumns = JSON.parse(storedColumns) as IDataGridColumnConfiguration[];

      const shouldSaveAgain = this.removeIfColumnShouldNotExist(parsedColumns);

      const fullColumns = [...parsedColumns, ...AllColumns.filter((m) => !parsedColumns.some((p) => p.dataKey === m.dataKey))];
      this.columns = fullColumns;

      if (shouldSaveAgain) {
        localStorage.setItem(columnKey, JSON.stringify(this.columns));
        this.forceUpdate();
      }
    }
  };

  setColumnsVersion = () => {
    localStorage.setItem(columnsVersionKey, this.columnsVersion);
  };

  removeIfColumnShouldNotExist = (parsedColumns: IDataGridColumnConfiguration[]): boolean => {
    let shouldSaveAgain = false;
    parsedColumns.forEach((parsedColumn, index) => {
      const targetColumn = AllColumns.find((column) => column.dataKey === parsedColumn.dataKey);

      if (!targetColumn) {
        parsedColumns.splice(index, 1);
        shouldSaveAgain = true;
      }
    });

    return shouldSaveAgain;
  };

  setColumns = (newColumns: IDataGridColumnConfiguration[]): void => {
    (this.columns as IObservableArray).replace(newColumns);
    localStorage.setItem(columnKey, JSON.stringify(this.columns));
    this.forceUpdate();
  };

  changeColumnVisibility = (columnName: string, isChecked: boolean): void => {
    const newColumns = this.columns;
    const columnItem = newColumns.find((column) => column.columnName === columnName);

    if (columnItem) {
      columnItem.isChecked = isChecked;
    }

    this.setColumns(newColumns);
  };

  forceUpdate = (): void => {
    this.shouldUpdate = uuid();
  };

  changeConfiguratorVisibility = (value: boolean): void => {
    this.isConfiguratorVisible = value;
  };

  countHiddenColumns = (): number => {
    let counter = 0;
    this.columns.forEach((column) => {
      if (!column.isChecked) {
        counter++;
      }
    });
    return counter;
  };

  changeAllColumns = (value: boolean): void => {
    this.columns.forEach((column) => {
      if (column.dataKey !== DataKey.TrackStartTimeLocal) {
        column.isChecked = value;
      }
    });
    this.setColumns(this.columns);
  };

  cleanupStore = (): void => {
    this.isConfiguratorVisible = false;
  };
}
